import SeoHead from "@/Component/Seo/SeoHead";
import CouponDetail from "@/Component/Module/CouponDetail";
import { serverFetchCouponDetail } from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { renderNotFoundPage } from "@/utils/detailSlug";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function CouponDetailPage({
  seo,
  seoCountry,
  couponSlug,
  initialCouponDetail,
}) {
  const fallbackTitle = initialCouponDetail?.offer_Heading || "Coupon Details";

  return (
    <>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle={`${fallbackTitle} | Next Holidays`}
      />
      <CouponDetail
        couponSlug={couponSlug}
        initialCouponDetail={initialCouponDetail}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const slugParam = context.params?.slug;
  const couponSlug = Array.isArray(slugParam) ? slugParam[0] : slugParam;

  if (!couponSlug) {
    return renderNotFoundPage(context);
  }

  const country = getCountryFromContext(context);
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  try {
    const response = await serverFetchCouponDetail(couponSlug, country);

    if (response?.status === "error" || !response?.data) {
      return renderNotFoundPage(context);
    }

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        couponSlug,
        initialCouponDetail: response.data,
      },
    };
  } catch (error) {
    console.error("Coupon detail page SSR error:", error);
    return renderNotFoundPage(context);
  }
}
